import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { User, Calendar, Tag, Eye, Bookmark, Check } from "lucide-react";
import ReactionBar from "./ReactionBar";
import CommentSection from "./CommentSection";
import ShareButtons from "./ShareButtons";
import "./Blog.css";

const BlogDetail = () => {
  const { id } = useParams(); // change param to 'id'
  const [blog, setBlog] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const userId = 1; // Replace with actual logged-in user ID if available
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    if (!id) return;

    fetch(`http://localhost:5000/api/blogs/${id}`) // fetch by ID now
      .then((res) => {
        if (!res.ok) throw new Error("Blog not found");
        return res.json();
      })
      .then((data) => {
        const desc =
          typeof data.description === "string"
            ? JSON.parse(data.description)
            : data.description;
        setBlog({ ...data, description: desc });
      })
      .catch((err) => {
        console.error("❌ Blog fetch error:", err);
        setBlog(null);
      });
  }, [id]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollProgress(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkSaved = async () => {
      try {
        const res = await fetch(`http://localhost:5000/api/save/${userId}`);
        const data = await res.json();
        const found = data.find((item) => item.blogId === id);
        setIsSaved(!!found);
      } catch (err) {
        console.error("❌ Save check failed:", err);
      }
    };

    if (id) checkSaved();
  }, [id]);

  const handleSave = async () => {
    try {
      const res = await fetch("http://localhost:5000/api/save", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, blogId: id }),
      });

      if (res.ok) {
        setIsSaved(true);
        alert("📌 Saved for later!");
      } else {
        alert("⚠️ Already saved or failed.");
      }
    } catch (err) {
      console.error("❌ Save failed:", err);
    }
  };

  if (!blog) return <p className="blog-detail-hbt-loading">Loading blog...</p>;

  const formattedDate = new Date(blog.publishedAt || blog.createdAt).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <div
        className="blog-scroll-progress-bar"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "4px",
          backgroundColor: "#D4AF37",
          width: `${scrollProgress}%`,
          zIndex: 9999,
          transition: "width 0.2s ease-out",
        }}
      ></div>

      <div className="blog-detail-hbt">
        {blog.isFeatured && <div className="blog-detail-hbt-highlight-tag">🔥 Featured</div>}

        <h1 className="blog-detail-hbt-title">{blog.title}</h1>

        <div className="blog-detail-hbt-meta">
          <div className="blog-detail-hbt-meta-texts" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
            <span className="blog-detail-hbt-author-name" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <User size={16} /> {blog.authorName || "Unknown Author"}
            </span>
            <span className="blog-detail-hbt-publish-date" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Calendar size={16} /> {formattedDate}
            </span>
            <span className="blog-detail-hbt-category" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Tag size={16} /> {blog.category || "Uncategorized"}
            </span>
            <span className="blog-detail-hbt-views" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <Eye size={16} /> {blog.views || 0} views
            </span>
          </div>
        </div>

        {blog.image1 && (
          <img
            src={`http://localhost:5000/${blog.image1}`}
            alt="Primary"
            className="blog-detail-hbt-image"
          />
        )}

        <div className="blog-detail-hbt-description">
          {Array.isArray(blog.description)
            ? blog.description.map((para, idx) => <p key={idx}>{para}</p>)
            : <p>{blog.description}</p>}
        </div>

        {blog.image2 && (
          <img
            src={`http://localhost:5000/${blog.image2}`}
            alt="Secondary"
            className="blog-detail-hbt-image-secondary"
          />
        )}

        {/* Save for Later */}
        {/* <button
          onClick={handleSave}
          disabled={isSaved}
          className="blog-detail-hbt-save-btn"
        >
          {isSaved ? <><Check size={18} /> Saved</> : <><Bookmark size={18} /> Save for Later</>}
        </button> */}

        <ReactionBar blogId={id} />
        <CommentSection blogId={id} />
        <ShareButtons blogUrl={window.location.href} blogTitle={blog.title} />
      </div>
    </>
  );
};

export default BlogDetail;
